import { render } from "./reservations.vue?vue&type=template&id=92cbc530&scoped=true"
import script from "./reservations.vue?vue&type=script&lang=js"
export * from "./reservations.vue?vue&type=script&lang=js"

import "./reservations.vue?vue&type=style&index=0&id=92cbc530&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-92cbc530"

export default script